export const getStatusLabel = (status) => {
    switch (status) {
        case 'pending':
            return <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-red-800 bg-red-100 rounded-full">Pendente</span>;
        case 'paid':
            return <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-green-800 bg-green-100 rounded-full">Pago</span>;
        case 'canceled':
            return <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-orange-800 bg-orange-100 rounded-full">Cancelado</span>;
        default:
            return <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-gray-800 bg-gray-100 rounded-full">Desconhecido</span>;
    }
}